module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgc3Ryb2tlPSIjOTU5NTk1IiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Im0xMy45MjYgMTMuNDA5LS40MjQuNDI0TDEuNDggMS44MTJsLjQyNC0uNDI0IDEyLjAyMSAxMi4wMloiLz48cGF0aCBkPSJtMS40ODEgMTMuNDA5LjQyNC40MjRMMTMuOTI2IDEuODEybC0uNDI0LS40MjRMMS40OCAxMy40MDhaIi8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/close.svg
// module id = tvNf
// module chunks = 41